<script lang="ts">
	let { title, description, children }: { title: string; description?: string; children: any } = $props();
</script>

<svelte:head>
	<title>{title} | Healthy Shoes Cyprus</title>
	{#if description}
		<meta name="description" content={description} />
	{/if}
	<meta property="og:type" content="website" />
	<meta property="og:title" content="{title} | Healthy Shoes Cyprus" />
	{#if description}
		<meta property="og:description" content={description} />
	{/if}
	<meta property="og:image" content="https://healthyshoes.com.cy/kybun1.jpg" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content="{title} | Healthy Shoes Cyprus" />
	{#if description}
		<meta name="twitter:description" content={description} />
	{/if}
	<meta name="twitter:image" content="https://healthyshoes.com.cy/kybun1.jpg" />
</svelte:head>

<div class="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
	<h1 class="mb-8 text-3xl font-bold text-gray-900 dark:text-white">{title}</h1>
	<div class="prose dark:prose-invert max-w-none">
		{@render children()}
	</div>
</div>
